<mat-form-field class="filtro-tabla">
  <mat-label>Filtrar</mat-label>
  <input
    matInput
    (keyup)="applyFilter($event)"
    placeholder="Buscar usuario..."
  />
</mat-form-field>
<div class="mat-elevation-z8">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    multiTemplateDataRows
    class="mat-elevation-z8"
  >
    <ng-container
      matColumnDef="{{ column }}"
      *ngFor="let column of columnsToDisplay"
    >
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "ALARM_TABLE." + column | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <p
          (click)="emitSelection(element)"
          *ngIf="
            column !== 'type' &&
            column !== 'param' &&
            column !== 'state' &&
            column !== 'activeElement'
          "
          [ngClass]="column === 'state' ? element.state : ''"
          class="noMarginBottom"
        >
          {{ element[column] }}
        </p>
        <!-- <p
          (click)="emitSelection(element)"
          *ngIf="column === 'type' && !tableUser"
          [ngClass]="column === 'state' ? element.state : ''"
          class="noMarginBottom"
        >
          {{ element[column]["name"] }}
        </p> -->
        <p
          (click)="emitSelection(element)"
          *ngIf="column === 'type' && !tableUser"
          class="noMarginBottom"
        >
          {{ element[column]["name"] }}
        </p>
        <!-- <p
          (click)="emitSelection(element)"
          *ngIf="column === 'param' && !tableUser"
          [ngClass]="column === 'state' ? element.state : ''"
          class="noMarginBottom"
        >
          {{ element[column]["valor"] }}
        </p> -->
        <p
          (click)="emitSelection(element)"
          *ngIf="column === 'param' && !tableUser"
          class="noMarginBottom"
        >
          {{ element[column]["valor"] }}
        </p>

        <div id="columnState" *ngIf="column === 'state'">
          <span [ngClass]="column === 'state' ? element.state : ''">{{
            "ALARM_TABLE." + element.state | translate
          }}</span>
        </div>

        <div *ngIf="column === 'state'" class="divButtonsAlarms">
          <div *ngIf="!tableUser">
            <div
              class="stateAlarmButton"
              [ngClass]="setStateStyles(element.state)"
            >
              <app-svg
                matTooltip="{{ 'ALARM.CHANGE_ALARM_STATE' | translate }}"
                matTooltipPosition="above"
                [matTooltipClass]="
                  element.state === 'Activada' ? 'desactive' : 'activeElement'
                "
                class="fillWhite"
                name="toggleStateAlarm"
                (click)="throwChangeStateEmitter(element)"
              ></app-svg>
            </div>
            <div class="removeAlarmButton">
              <app-svg
                matTooltip="{{ 'ALARM.DELETE_ALARM' | translate }}"
                matTooltipPosition="above"
                matTooltipClass="deleteAlarm1"
                class="fillWhite"
                name="deleteAlarm"
                (click)="throwDeleteEmitter(element)"
              ></app-svg>
            </div>
            <div class="editAlarmButton">
              <app-svg
                matTooltip="{{ 'ALARM.EDIT_ALARM' | translate }}"
                matTooltipPosition="above"
                matTooltipClass="editAlarm1"
                class="fillWhite"
                name="editAlarm"
                (click)="throwEditEmitter(element)"
              ></app-svg>
            </div>
          </div>
          <div *ngIf="tableUser">
            <div
              class="stateUserButton"
              [ngClass]="setStateStyles(element.state)"
            >
              <app-svg
                matTooltip="{{ 'USER.CHANGE_USER_STATE' | translate }}"
                matTooltipPosition="above"
                [matTooltipClass]="
                  element.state === 'Desactivado'
                    ? 'activeElement'
                    : 'desactive'
                "
                class="fillWhite"
                name="toggleStateAlarm"
                (click)="throwChangeStateEmitter(element)"
              ></app-svg>
            </div>
            <div class="removeUserButton">
              <app-svg
                matTooltip="{{ 'USER.DELETE_USER' | translate }}"
                matTooltipPosition="above"
                matTooltipClass="deleteAlarm1"
                class="fillWhite"
                name="deleteAlarm"
              ></app-svg>
              <!--  (click)="throwDeleteEmitter(element)" (click)="throwDeleteEmitter(element)" -->
            </div>
            <div class="editUserButton">
              <app-svg
                matTooltip="{{ 'USER.EDIT_USER' | translate }}"
                matTooltipPosition="above"
                matTooltipClass="editAlarm1"
                class="fillWhite"
                name="editAlarm"
                (click)="throwEditEmitter(element)"
              ></app-svg>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr
      mat-row
      *matRowDef="let element; columns: columnsToDisplay"
      class="example-element-row pointer rowAlarm"
    ></tr>
  </table>
  <mat-paginator
    [pageSizeOptions]="[10, 20, 25]"
    showFirstLastButtons
  ></mat-paginator>
</div>
